import React from 'react';
import EditCoupon from 'containers/Coupons/EditCoupon';

const EditCouponPage = () => <EditCoupon />;

export default EditCouponPage;
